<template>
  <div>
    <v-card class="Kanit pa-4">
      <div class="text-right">
        <v-btn @click="cancelAddProduct" icon>
          <v-icon>close</v-icon>
        </v-btn>
      </div>
      <ValidationObserver ref="observerProduct">
        <ValidationProvider
          name="หมายเลขรับประกัน"
          v-slot="{ errors }"
          :rules="{
            required: true,
          }"
        >
          <div class="primary--text pt-3">
            หมายเลขรับประกัน <span class="red--text"> *</span>
          </div>
          <div
            class="pt-1 pb-2 Kanit grey--text"
            style="font-size: 12px; line-height: 18px;"
          >
            <span style="text-decoration: underline;">ตัวอย่าง</span>
            การใส่เลขประกัน RT 01-xxxxxxx (มีเว้นวรรค หลังตัวอักษรไม่ต้องมีขีด)
          </div>
          <custom-input
            v-model="input.warrantyNumber"
            :error-messages="errors"
            placeholder="กรอกหมายเลขรับประกัน 0x xx-xxxxxxxxx"
            maxlength="15"
          ></custom-input>

          <div
            style="font-size: 12px; color: #b71c1c !important;"
            v-if="errors"
          >
            {{ errors[0] }}
          </div>
        </ValidationProvider>
        <ValidationProvider
          name="รหัสรุ่นสินค้า"
          v-slot="{ errors }"
          :rules="{
            required: true,
          }"
        >
          <div class="primary--text pt-3">
            รหัสรุ่นสินค้า <span class="red--text"> *</span>
          </div>
          <div
            class="pt-1 pb-2 Kanit grey--text"
            style="font-size: 12px; line-height: 18px;"
          >
            <span style="text-decoration: underline;">ตัวอย่าง</span>
            รหัสสินค้าใส่ 344-xxxxxxx (ไม่มีเว้นวรรค หลังตัวอักษร)
          </div>
          <!-- maxlength="11" -->
          <custom-input
            v-model="input.sku"
            :error-messages="errors"
            placeholder="กรอกรหัสรุ่นสินค้า xxx-xxxxxxx"
          ></custom-input>
          <div
            style="font-size: 12px; color: #b71c1c !important;"
            v-if="errors"
          >
            {{ errors[0] }}
          </div>
        </ValidationProvider>
        <v-layout v-if="!isValidWarrantyNumber">
          <v-flex xs12 class="pt-5 text-right">
            <v-btn
              :loading="checkloading"
              @click="checkWarrantyNumber"
              tile
              dark
              color="#000"
              style=" margin-bottom: 8px;"
              class="py-1"
            >
              <span style="font-size: 14px;">ตรวจสอบความถูกต้อง</span>
            </v-btn>
          </v-flex>
        </v-layout>
        <template v-if="productType !== 'ของขวัญ' && isValidWarrantyNumber">
          <ValidationProvider
            name="ราคาสินค้า"
            v-slot="{ errors }"
            :rules="{
              required: true,
            }"
          >
            <div class="primary--text pt-3">
              ราคาสินค้า <span class="red--text"> *</span>
            </div>
            <custom-input
              readonly
              v-model="input.price"
              :error-messages="errors"
              placeholder="กรอกราคาสินค้า"
              type="number"
            ></custom-input>
            <div
              style="font-size: 12px; color: #b71c1c !important;"
              v-if="errors"
            >
              {{ errors[0] }}
            </div>
          </ValidationProvider>
        </template>
      </ValidationObserver>

      <!-- Button -->
      <v-layout v-if="isValidWarrantyNumber">
        <v-flex xs12 class="pt-5">
          <v-btn
            :loading="saveloading"
            @click="saveProduct"
            tile
            dark
            color="#000"
            style="width: 100%; height: 48px; margin-bottom: 8px;"
          >
            <span style="font-size: 16px;">ยืนยัน</span>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-card>
  </div>
</template>

<script>
import axios from "axios";

export default {
  props: ["productType"],
  data() {
    return {
      input: {
        warrantyNumber: "",
        sku: "",
        price: 0,
      },
      testWarranty: [
        { code: "TE-123456789", price: "1990" },
        { code: "ZW-987654321", price: "990" },
        {
          code: "TH-1234444412",
        },
      ],
      saveloading: false,
      checkloading: false,
      isValidWarrantyNumber: null,
      isInvalidCount: 0,
    };
  },
  mounted() {
    this.isValidWarrantyNumber = false;
  },
  methods: {
    async checkWarrantyNumber() {
      if (await this.$refs.observerProduct.validate()) {
        this.checkloading = true;
        var type;
        if (this.productType == "ซื้อสินค้า") {
          type = "purchase";
        } else {
          type = "gift";
        }

        var data = {
          pageid: this.$store.state.pageid,
          warranty_number: this.input.warrantyNumber, // เลขประกันสินค้า
          sku: this.input.sku, // รหัสสินค้า
          types: type,
        };

        axios
          .get(this.serverUrl + "lamy/check-warranty-sku", {
            headers: { AUTHORIZATION: "Bearer xxx xxx" },
            params: data,
          })
          .then(async (response) => {
            if (response.data.responsecode == 200) {
              // var isValid = response.data.data[0].flag;
              var price = response.data.data[0].price;
              // var isUsed = response.data.data[0].warranty_used;

              if (price) {
                this.checkloading = false;
                this.isValidWarrantyNumber = true;

                if (this.productType == "ซื้อสินค้า") {
                  if (price) {
                    this.input.price = price;
                  } else {
                    this.input.price = "0";
                  }
                }
                // if(isUsed) {
                //   this.isInvalidCount++;
                //   this.$swal.fire({ html: 'หมายเลขรับประกันสินค้านี้ได้ถูกลงทะเบียนแล้ว, <br>กรุณาลองใหม่อีกครั้ง.' });
                // } else {
                //
                //   if(this.productType == 'ซื้อสินค้า') {
                //     if(price) {
                //       this.input.price = price;
                //     } else {
                //       this.input.price = '';
                //     }
                //   }
                // }
              } else {
                //Warranty number not found
                this.checkloading = false;
                this.isInvalidCount++;
                this.$swal.fire({
                  html:
                    "ไม่พบหมายเลขรับประกันสินค้านี้, <br>กรุณาลองใหม่อีกครั้ง.",
                  confirmButtonColor: "#000",
                });
              }

              if (this.isInvalidCount == 3) {
                this.onNoticeToAdmin();
              }
            } else if (response.data.responsecode == 204) {
              this.checkloading = false;
              await this.$swal.fire({
                text: response.data.reason,
                confirmButtonColor: "#000",
              });
              this.isInvalidCount++;

              if (this.isInvalidCount == 3) {
                this.onNoticeToAdmin();
              }
            } else {
              this.checkloading = false;
              await this.$swal.fire({
                text: response.data.reason,
                confirmButtonColor: "#000",
              });
              this.$liff.closeWindow();
            }
          });
      }
    },
    async saveProduct() {
      if (await this.$refs.observerProduct.validate()) {
        var productItem = {
          warranty_number: this.input.warrantyNumber,
          sku: this.input.sku,
          amounts: this.input.price,
          types: this.productType,
        };
        this.$emit("addProduct", productItem);
        this.cancelAddProduct();
      }
    },
    onNoticeToAdmin() {
      this.$store.dispatch("sendMessage", "ติดต่อเจ้าหน้าที่");
      this.$emit("close");
      this.cancelAddProduct();
      this.$liff.closeWindow();
    },
    cancelAddProduct() {
      this.$refs.observerProduct.reset();
      this.input = {
        warrantyNumber: "",
        sku: "",
        price: 0,
      };

      this.isValidWarrantyNumber = false;
      this.$emit("close");
    },
  },
  filters: {
    numberCurrency: function(value) {
      var formatter = new Intl.NumberFormat({
        style: "currency",
      });

      return formatter.format(value);
    },
  },
};
</script>

<style lang="scss" scoped>
.v-text-field {
  padding-top: 0 !important;
  // margin-bottom: 24px !important;
}
</style>
